const CustomCategoryImage = require('./custom-category.png');

export const assets = {
  CustomCategoryImage,
};
